import communityHttpClient from './httpClient';
import COMMUNITY_ENDPOINTS from './endpoints';

const AUTH_ENDPOINTS = COMMUNITY_ENDPOINTS.AUTH;

export const register = (data) =>
  communityHttpClient.post(AUTH_ENDPOINTS.REGISTER, data);

export const login = (data) =>
  communityHttpClient.post(AUTH_ENDPOINTS.LOGIN, data);

export const logout = () =>
  communityHttpClient.post(AUTH_ENDPOINTS.LOGOUT);

export const session = () =>
  communityHttpClient.get(AUTH_ENDPOINTS.SESSION, { skipAuthRefresh: true });

export const refresh = () =>
  communityHttpClient.post(AUTH_ENDPOINTS.REFRESH, {}, { skipAuthRefresh: true });

export const verifyOTP = (username, otp) =>
  communityHttpClient.post(AUTH_ENDPOINTS.VERIFY_OTP, { username, otp });

export const resendOTP = (username) =>
  communityHttpClient.post(AUTH_ENDPOINTS.RESEND_OTP, { username });

export const forgotPassword = (email) =>
  communityHttpClient.post(AUTH_ENDPOINTS.FORGOT_PASSWORD, { email });

export const resetPassword = (token, newPassword) =>
  communityHttpClient.post(AUTH_ENDPOINTS.RESET_PASSWORD, {
    token,
    new_password: newPassword
  });

export const googleLogin = (token, termsAccepted = false) =>
  communityHttpClient.post(AUTH_ENDPOINTS.GOOGLE_LOGIN, { token, terms_accepted: termsAccepted });

export default {
  register,
  login,
  logout,
  session,
  refresh,
  verifyOTP,
  resendOTP,
  forgotPassword,
  resetPassword,
  googleLogin
};
